<template>
    <div>
        <PmisTitle title="Tržnica rešitev"></PmisTitle>
        <PmisHeader></PmisHeader>
        <pmis-osnovna-vsebina-desc class="margin" :description="htmlDescription"></pmis-osnovna-vsebina-desc>
        <pmis-search-container class="margin"></pmis-search-container>
        <pmis-search-result-container class="margin"></pmis-search-result-container>
    </div>
</template>

<script>
    import PmisHeader from "../title/PmisHeader";
    import PmisTitle from "../title/PmisTitle";
    import PmisOsnovnaVsebinaDesc from "./../presentation/desc/PmisOsnovnaVsebinaDesc";
    import PmisSearchContainer from "./search/PmisSearchContainer";
    import PmisSearchResultContainer from "./search/PmisSearchResultContainer";

    export default {
        name: 'PmisResitevPresentation',
        props: {
            msg: String
        },
        components: {
            PmisTitle,
            PmisHeader,
            PmisOsnovnaVsebinaDesc,
            PmisSearchContainer,
            PmisSearchResultContainer
        },
        computed: {
            htmlDescription() {
                return "<span class='expose'>Digitalna tržnica</span> je spletni prostor, kjer lahko najdete različne rešitve s področja pametnih mest in skupnosti. Razvrščene so po <span class='expose'>ključnih domenah</span> pametnega mesta in\n" +
                    "skupnosti: <span class='expose'>upravljanje z viri in infrastrukturo</span> (npr. rešitve s področja energetike), <span class='expose'>zdravo in aktivno življenje</span> (npr. rešitve za oddaljeno oskrbo bolnikov ali razne rešitve za\n" +
                    "spodbujanje zdravega in aktivnega življenja), <span class='expose'>pridelava in oskrba</span> (npr. rešitve s področja agrikulture), <span class='expose'>skrb za okolje</span> (npr. rešitve na področju ravnanja z odpadki), rešitve\n" +
                    "s področja <span class='expose'>mobilnosti, logistike in transporta</span> (npr. rešitve s področja upravljanja prometa), <span class='expose'>varnost in zaščita</span> (npr. podpora ravnanju ob naravnih nesrečah), <span class='expose'>vključenost in soodločanje</span> (npr. rešitve, ki spodbujajo k večji vključenosti in angažiranosti družbe) ter <span class='expose'>zaposlovanje in razvoj gospodarstva</span> (npr. rešitve za pomoč pri iskanju kadrov\n" +
                    "in zaposlitvenih možnosti). Na tržnici lahko objavljate <span class='expose'>celovite rešitve, mobilne aplikacije, spletne portale, podatke in storitve</span> ter <span class='expose'>strojne opremo, naprave</span> in <span class='expose'>senzorje</span>.";
            }
        }

    }
</script>

<style scoped lang="scss">
    .margin{
        margin-top: 10px;
    }
</style>
